import leoProfanity from 'leo-profanity';
import Cookies from 'js-cookie';
export const checkProfanity = (name) => {
    if (!name)
        return false;
    const user = Cookies.get('user');
    const language = user
        ? JSON.parse(user).details?.selected_language || 'en'
        : 'en';
    const words = name.toLowerCase().split(/_+|-/) || [];
    // Load the appropriate language dictionary if supported
    try {
        leoProfanity.loadDictionary(language);
        for (let word of words) {
            if (word && leoProfanity.check(word)) {
                return true;
            }
        }
    }
    catch (error) {
        // If language not supported, log the error and fallback to English
        console.warn(`Failed to load '${language}' dictionary; falling back to 'en'`, error);
        leoProfanity.loadDictionary('en');
    }
    return leoProfanity.check(name);
};
